const AppURLs = {
  termsOfUse: 'https://www.fiveirongolf.com/en-us/terms-and-conditions',
  privacyPolicy: 'https://fiveirongolf.com/privacy-policy/',
};

export default AppURLs;
